// extracted by mini-css-extract-plugin
export default {"wrapper":"CancelReasonsForm-module__wrapper___xBnuj","title":"CancelReasonsForm-module__title___nFUO3","reason":"CancelReasonsForm-module__reason___I4b2Q"};